import script from "./LiveSportOverviewCompetition.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSportOverviewCompetition.vue?vue&type=script&setup=true&lang=js"

import "./LiveSportOverviewCompetition.vue?vue&type=style&index=0&id=2b8ff1bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b8ff1bb"]])

export default __exports__